import { PaymentDataModel } from "../../data/models/Soul/PaymentDataModel";

export const paymentColumns = [
  {
    name: "Sesión Stripe",
    selector: (row: PaymentDataModel) => row.stripeSessionId ?? "—",
    sortable: true,
    wrap: true,
  },
  {
    name: "Correo",
    selector: (row: PaymentDataModel) => row.soul?.email ?? "—",
    sortable: true,
    wrap: true,
  },
  {
    name: "Estado",
    selector: (row: PaymentDataModel) => row.status ?? "—",
    sortable: true,
    cell: (row: PaymentDataModel) => (
      <span
        style={{
          fontWeight: "bold",
          color:
            row.status === "COMPLETED"
              ? "#2e7d32"
              : row.status === "CREATED"
              ? "#ed6c02"
              : "#d32f2f",
          textTransform: "capitalize",
        }}
      >
        {row.status?.toLowerCase() ?? "—"}
      </span>
    ),
  },
  {
    name: "Plan",
    selector: (row: PaymentDataModel) => row.plan?.name ?? "—",
    sortable: true,
  },
  {
    name: "Monto",
    selector: (row: PaymentDataModel) =>
      row.amountUsd !== undefined ? `${row.amountUsd} $` : "—",
    sortable: true,
  },
  {
    name: "Creado",
    selector: (row: PaymentDataModel) =>
      row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "—",
    sortable: true,
  },
  {
    name: "Actualización",
    selector: (row: PaymentDataModel) =>
      row.updatedAt ? new Date(row.updatedAt).toLocaleDateString() : "—",
    sortable: true,
  },
];
